import React from 'react';
import { Form, Input } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import generateTestId from 'packages/helpers/testIdHelpers';
import { useBaseFontSettingInput } from './useBaseFontSettingInput';

type Props = {
    fontSizeData: [number, boolean, string];
    onFontSizeChange: (fontSize: number) => void;
    disabled?: boolean;
    locked?: boolean;
};

const FontSizeBase = ({ fontSizeData, onFontSizeChange, disabled, locked }: Props) => {
    const { translate } = useTranslate();
    const label = translate('editor.sidebar.shots.fonts.size');
    const [prop, isMixed, mixedValue] = fontSizeData;

    const attrs = useBaseFontSettingInput({
        prop,
        isMixed,
        mixedValue,
        autoCorrectKey: 'text_element_font_size',
        disabled: !!disabled,
        locked: !!locked,
        onSubmit: (value) => onFontSizeChange(Number(value)),
    });

    return (
        <Form.Group>
            <Input {...attrs} name={label} aria-label={label} suffix="px" {...generateTestId('shots_text_size')} />
        </Form.Group>
    );
};

export { FontSizeBase };
